"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
const configsBase_1 = require("../configsBase");
const store_1 = require("../../store");
class Config extends configsBase_1.ConfigCommon {
    constructor() {
        super(...arguments);
        this.getSessionStoreConfig = () => ({
            store: (0, store_1.getDefaultCookiesStore)({ credentialsDomain: this.getLoginDomain(), path: '/' }),
        });
        this.bankId = 'SB_CO';
        this.language = 'es-CO';
    }
}
exports.Config = Config;
//# sourceMappingURL=config.js.map